<template>
    <div class="container">
        <div class="d-flex justify-content-between">
        <h1>Instrument Tags</h1>
        <b-button v-if="editingTagType.id === null" size="sm" class="mb-1 float-right" @click="setNewTag()">Add New</b-button>
    </div>
    <div v-if="serverError" class="alert alert-danger" role="alert">
      {{serverError}}
    </div>
    <div v-if="validationErrors.length > 0" class="alert alert-danger" role="alert">
      <ul>
        <template v-for="(error, index) in validationErrors">
          <li :key="index">{{error}}</li>
        </template>
      </ul>
    </div>
    <div>
        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col">
                    <span class='search-result-header'>Tag ID</span>
                </th>
                <th scope="col">
                    <span class='search-result-header'>Tag Name</span>
                </th>
                <th scope="col">
                    <span class='search-result-header'>Usage Count</span>
                </th>
                <th scope="col"/>
            </tr>
            </thead>
            <tbody>
              <tr v-if="editingTagType.id === 0">
                <td></td>
                  <td>
                    <input
                      v-model="editingTagType.name"
                      name="tagName"
                    />
                  </td>
                  <td>0</td>
                  <td>
                    <b-button size="sm" class="button-row-spacing float-right" @click="updateOrCreateTagType()">Save</b-button>
                    <b-button size="sm" variant="danger" class="button-row-spacing float-right" @click="cancelEdit()">Cancel</b-button>
                  </td>
              </tr>
              <template v-for="tag in tagTypes">
                <tr v-if="tag.id !== editingTagType.id" :key="tag.id" class="list-table-text">
                    <td>{{ tag.id }}</td>
                    <td> {{ tag.name }}</td>
                    <td>{{ tag.usageCount }}</td>
                    <td v-if="tag.canEdit">
                      <b-button size="sm" :disabled="editingTagType.id !== null" class="button-row-spacing float-right" @click="setEditingTag(tag)">
                        <font-awesome-icon icon="pen" class="text-white" fixed-width />
                      </b-button>
                      <b-button size="sm" v-b-modal="`deleteConfirmation-${tag.id}`" :disabled="editingTagType.id !== null" variant="danger" class="button-row-spacing float-right">
                        <font-awesome-icon icon="trash-alt" class="text-white" fixed-width />
                      </b-button>
                    </td>
                    <td v-else></td>
                </tr>
                <tr v-else :key="tag.id" class="list-table-text">
                  <td>{{tag.id}}</td>
                  <td>
                    <input
                      v-model="editingTagType.name"
                      name="tagName"
                    />
                  </td>
                  <td>{{ tag.usageCount }}</td>
                  <td>
                    <b-button size="sm" class="button-row-spacing float-right" @click="updateOrCreateTagType()">Save</b-button>
                    <b-button size="sm" variant="danger" class="button-row-spacing float-right" @click="cancelEdit()">Cancel</b-button>
                  </td>
                </tr>
                <DeleteModal
                  :key="`deleteModal-${tag.id}`"
                  :modalId="`deleteConfirmation-${tag.id}`"
                  :deleteDisplayName="'Delete Instrument Tag'"
                  :deletePrompt="'Deleting a tag removes it from all Instruments that currently use it. Are you sure you want to delete this tag?'"
                  @deleteConfirmed="deleteTag(tag.id)">
               </DeleteModal>
              </template>
            </tbody>
        </table>
      </div>

    </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex';
import DeleteModal from '../components/DeleteModal.vue';
import { LookupModules } from '@/store/moduleConfig';

const emptyTag = {
  id: null,
  name: '',
  canEdit: true,
};
export default {
  name: 'InstrumentTags',
  components: {
    DeleteModal,
  },
  data() {
    return {
      editingTagType: emptyTag,
      validationErrors: [],
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.TAG_TYPES.namespace}/fetchOptions`,
      LookupModules.TAG_TYPES.url);
  },
  computed: {
    ...mapState(LookupModules.TAG_TYPES.namespace, {
      tagTypesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.TAG_TYPES.namespace, {
      tagTypes: 'getActiveOptions',
    }),
    ...mapState('Instrument', {
      serverError: state => state.serverError,
    }),
  },
  methods: {
    setEditingTag(tag) {
      this.editingTagType = { ...tag };
    },
    cancelEdit() {
      this.editingTagType = { ...emptyTag };
    },
    setNewTag() {
      this.editingTagType = { ...emptyTag };
      this.editingTagType.id = 0;
    },
    updateOrCreateTagType() {
      if (!this.isTagValid()) return;
      this.$store.dispatch('Instrument/startSubmittingTagType');
      this.$store.dispatch('Instrument/updateOrCreateTagType', { entity: this.editingTagType, submittedCallback: this.resetForm });
    },
    createTag() {
      this.$store.dispatch('Instrument/startSubmittingTagType');
      this.$store.dispatch('Instrument/createTagType', { entity: this.editingTagType, submittedCallback: this.resetForm });
    },
    deleteTag(tagId) {
      this.$store.dispatch('Instrument/deleteTagType', { id: tagId });
    },
    resetForm(entity) {
      if (entity && entity.id) {
        this.editingTagType = emptyTag;
        this.validationErrors = [];
      }
    },
    isTagValid() {
      this.validationErrors = [];
      if (this.editingTagType.name.length === 0) {
        this.validationErrors.push('Tag name must be at least one character long.');
      }
      if (this.editingTagType.name.length > 100) {
        this.validationErrors.push('Please shorten the tag name.');
      }
      const names = this.tagTypes.map(x => x.name);
      if (names.includes(this.editingTagType.name)) {
        this.validationErrors.push('This tag name already exists. Please enter a unique tag.');
      }
      return this.validationErrors.length === 0;
    },
  },
};
</script>
